import cacheEnhancer from "./cacheEnhancer";
import instance from "./instance";
import { parseUserDate } from "./users.js";

const parseLibrary = library => {
	return {
		...library,
		services: library.services ? library.services : [],
		profiles: library.profiles.map(profile => ({
			...profile,
			multiSelect: !!profile.multi_select,
		})),
	};
};

export function login(email, password, remember) {
	return instance
		.request({
			url: "/register/login",
			method: "POST",
			data: {
				email,
				password,
				remember,
			},
		})
		.then(() => {});
}

export function device(email, password, push_service, push_key, device_title) {
	return instance
		.request({
			url: "/register/device",
			method: "POST",
			data: {
				email,
				password,
				push_service,
				push_key,
				device_title,
			},
		})
		.then(response => response.data);
}

export function resetPassword(email) {
	return instance
		.request({
			url: "/register/reset_password",
			method: "POST",
			data: {
				email,
			},
		})
		.then(() => {});
}

export function setPassword(guid, password) {
	return instance
		.request({
			url: "/register/set_password",
			method: "POST",
			data: {
				guid,
				password,
			},
		})
		.then(() => {});
}

export function group(contact_info, filename, attachment) {
	return instance
		.request({
			url: "/register/group",
			method: "POST",
			data: {
				contact_info,
				attachment,
				filename,
			},
		})
		.then(() => {});
}

export function groupMember(email, password) {
	return instance.request({
		url: "/register/group_member",
		method: "POST",
		data: {
			email,
			password,
		},
	});
}

function fetchLibraries() {
	return instance
		.request({
			url: "/register/libraries",
			method: "POST",
		})
		.then(response => response.data.map(parseLibrary));
}

export const libraries = cacheEnhancer(fetchLibraries, "libraries", 600, true);

export function individualUser(profile) {
	return instance
		.request({
			url: "/register/individual_user",
			method: "POST",
			data: {
				...profile,
			},
		})
		.then(response => parseUserDate(response.data));
}

export function groupLibraries(guid) {
	return instance
		.request({
			url: "/register/group_libraries",
			method: "POST",
			data: {
				guid,
			},
		})
		.then(response => response.data);
}

export function shortcut(profile, guid) {
	return instance
		.request({
			url: "/register/shortcut",
			method: "POST",
			data: {
				...profile,
				guid,
			},
		})
		.then(response => parseUserDate(response.data));
}
